import { InternalAccessor } from '@billy/design-system'

import { ContactPerson } from '../../../../../../../types/contactPerson'
import { placePrimaryContactFirst } from '../../../../../../../utils/placePrimaryContactFirst'
import { CompanyContactPersonsTableAccessor } from '../../../../../enums/companyContactPersonsTableAccessor'
import { CompanyContactPersonsTableRow } from '../../../../../types/companyContactPersonsTableRow'

export const getCompanyContactPersonsTableData = (
  companyContacts: ContactPerson[],
): CompanyContactPersonsTableRow[] => {
  const orderedContactPersons = placePrimaryContactFirst(companyContacts)

  return orderedContactPersons.map(({ email, firstName, id, isPrimary, lastName }) => {
    const fullName = `${firstName || ''} ${lastName || ''}`.trim()

    return {
      id: id ?? '',
      [CompanyContactPersonsTableAccessor.EmailAddress]: email,
      [CompanyContactPersonsTableAccessor.FirstName]: firstName,
      [CompanyContactPersonsTableAccessor.FullName]: fullName,
      [CompanyContactPersonsTableAccessor.IsPrimary]: isPrimary,
      [CompanyContactPersonsTableAccessor.LastName]: lastName,
      [InternalAccessor.HoverActions]: true,
    }
  })
}
